var FormEmailSignup = (function () {
  

  Utility.log('FormEmailSignup loaded');

  var $formCntr;
  var $form;

  var avoidTextCursorPostSubmit = function () {
    setTimeout(function () {
      $('input[type=text]:focus', $form).blur();
      // console.log('Focused input now blurred.');
    }, 250);
  };

  var attachListeners = function () {
    if (Utility.isEdge()) {
      $form.on('submit', avoidTextCursorPostSubmit);
    }
  };

  var init = function () {
    if ($('.acr-sign-up-form-emails').length > 0) {
      $formCntr = $('.acr-sign-up-form-emails');
      $form = $('form', $formCntr);

      attachListeners();

      // console.log('FormEmailSignup initialized');
    }
  };

  return {
    init: init,
  };
}());
